<ion-content fullscreen="true">
    <ion-row class="">
      <ion-col size="12" size-lg="6">
        <ion-button class="back-button" color="light" (click)="goBack()">Back</ion-button>
        <app-login-banner></app-login-banner>
      </ion-col>
      <ion-col style="display: flex; flex-direction: column; justify-content: center;" size="12" size-lg="6">
        <ion-card>
<!--          <h4>{{ forgotPassword ? 'Reset Password' : 'Login to your account' }}</h4>-->
<!--          @if (!forgotPassword) {-->
<!--          <ion-segment-->
<!--            [(ngModel)]="formType" [value]="formType">-->
<!--            <ion-segment-button [routerLink]="['/user/login']" value="login">Login</ion-segment-button>-->
<!--            <ion-segment-button [routerLink]="['/user/register']" value="register">Register</ion-segment-button>-->
<!--          </ion-segment>-->
<!--          }-->
          @switch (formType) {
            @case ('login') {
              <app-login (isForgotPassword)="isForgotPasswordEvent($event)"></app-login>
            }
            @case ('register') {
              <app-register></app-register>
            }
            @default {
              <app-login></app-login>
            }
          }
<!--          <ion-segment-view>-->
<!--            <ion-segment-content id="login">-->
<!--              <app-login></app-login>-->
<!--            </ion-segment-content>-->
<!--            <ion-segment-content id="register">-->
<!--              <app-register></app-register>-->
<!--            </ion-segment-content>-->
<!--          </ion-segment-view>-->
        </ion-card>
      </ion-col>
    </ion-row>
</ion-content>
